module.exports = __webpack_public_path__ + "static/media/main.7b94382f.png";